import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import SBoxTable from './sbox';
import { useState } from 'react';

const Page3 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  const userInput = location.state.userInput;
  const userKey = location.state.userKey;
  let hexInput = userKey;
  const allEncResults = location.state.allEncResults;
  console.log("allEncResults", allEncResults);
  let { round } = rond;
  round = round -1;
  round = round / 4;


  const firstpage = () => {
    navigate("/page2", {
      state: { allResults, allEncResults, userInput, hexInput },
    });
  };

  const secondpage = () => {
    navigate("/page4" , { state: { allResults, allEncResults, userInput, userKey, cols } });
  };

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data0 = allEncResults[0][round].toString().split(" ");

  let cols = [
    [data0.slice(0, 4)],
    [data0.slice(4, 8)],
    [data0.slice(8, 12)],
    [data0.slice(12, 16)],
  ];

  console.log(cols);
  let data = allEncResults[1][round].toString().split(" ");
  console.log("data", data);

  let cols2 = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];


  const renderTable = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  const renderTable2 = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols2[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  const sBoxData = [
    [
      "52", "09", "6a", "d5", "30", "36", "a5", "38", "bf", "40", "a3", "9e", "81", "f3", "d7", "fb",
    ],
    [
      "7c", "e3", "39", "82", "9b", "2f", "ff", "87", "34", "8e", "43", "44", "c4", "de", "e9", "cb",
    ],
    [
      "54", "7b", "94", "32", "a6", "c2", "23", "3d", "ee", "4c", "95", "0b", "42", "fa", "c3", "4e",
    ],
    [
      "08", "2e", "a1", "66", "28", "d9", "24", "b2", "76", "5b", "a2", "49", "6d", "8b", "d1", "25",
    ],
    [
      "72", "f8", "f6", "64", "86", "68", "98", "16", "d4", "a4", "5c", "cc", "5d", "65", "b6", "92",
    ],
    [
      "6c", "70", "48", "50", "fd", "ed", "b9", "da", "5e", "15", "46", "57", "a7", "8d", "9d", "84",
    ],
    [
      "90", "d8", "ab", "00", "8c", "bc", "d3", "0a", "f7", "e4", "58", "05", "b8", "b3", "45", "06",
    ],
    [
      "d0", "2c", "1e", "8f", "ca", "3f", "0f", "02", "c1", "af", "bd", "03", "01", "13", "8a", "6b",
    ],
    [
      "3a", "91", "11", "41", "4f", "67", "dc", "ea", "97", "f2", "cf", "ce", "f0", "b4", "e6", "73",
    ],
    [
      "96", "ac", "74", "22", "e7", "ad", "35", "85", "e2", "f9", "37", "e8", "1c", "75", "df", "6e",
    ],
    [
      "47", "f1", "1a", "71", "1d", "29", "c5", "89", "6f", "b7", "62", "0e", "aa", "18", "be", "1b",
    ],
    [
      "fc", "56", "3e", "4b", "c6", "d2", "79", "20", "9a", "db", "c0", "fe", "78", "cd", "5a", "f4",
    ],
    [
      "1f", "dd", "a8", "33", "88", "07", "c7", "31", "b1", "12", "10", "59", "27", "80", "ec", "5f",
    ],
    [
      "60", "51", "7f", "a9", "19", "b5", "4a", "0d", "2d", "e5", "7a", "9f", "93", "c9", "9c", "ef",
    ],
    [
      "a0", "e0", "3b", "4d", "ae", "2a", "f5", "b0", "c8", "eb", "bb", "3c", "83", "53", "99", "61",
    ],
    [
      "17", "2b", "04", "7e", "ba", "77", "d6", "26", "e1", "69", "14", "63", "55", "21", "0c", "7d",
    ]
  ];

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <>
    {isVisible && (
        <div className="fixed top-16 right-8 h-3/5 w-1/5 rounded-xl bg-emerald-100 shadow p-4">
          <div className="text-center">
            <h2 className="text-xl pb-10 pt-4 font-semibold">
              How S-box Substitution is performed
            </h2>
            <p className="text-sm">
              every element in initial transformation matrix has 2 parts
              <br />
              <br />
              the first part represents the row and the
              <br />
              <br />
              the second part represents the column
              <br />
              <br />
              look up the respective element in s-box and fill the After S-box substition matrix
            </p>
          </div>
        </div>
      )}
      
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-2xl">Round {round+1}</h2>
            <h2 className=" font-semibold text-xl">Step 1</h2>
            <h2 className=" font-semibold text-xl">S-Box Substitution</h2>
            

            <div className="grid grid-flow-col grid-cols-5 gap-2 align-middle pt-28">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit pl-5"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">{renderTable()}</tbody>
                </table>
                <p className="align-middle"> Initial transformation</p>
              </motion.div>

              <div className=" pt-20 pl-7">
                <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">{renderTable2()}</tbody>
                </table>
                <p className="align-middle"> After S-box substition</p>
              </motion.div>

              <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 1.5 }}
             >
            <SBoxTable sBoxData={sBoxData} highlightedRow={cols[0][0][0][0]} highlightedColumn={cols[0][0][0][1]} />
            </motion.div>
            
            </div>
            <div className="bg-emerald-100 rounded-xl w-20 p-2 ml-60">
            <p
              style={{ cursor: 'pointer',}}
              onClick={toggleVisibility}
            >
              Explain
            </p>
            </div>
            
          </div>
        </div>
      </div>
      {/* <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={secondpage}>
          NEXT
        </div>
      </div> */}
    </>
  );
};

export default Page3;
